var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0H30.5C30.8978 0 31.2794 0.158035 31.5607 0.43934C31.842 0.720644 32 1.10218 32 1.5C32 1.89782 31.842 2.27936 31.5607 2.56066C31.2794 2.84196 30.8978 3 30.5 3H1.5C1.10218 3 0.720644 2.84196 0.43934 2.56066C0.158035 2.27936 0 1.89782 0 1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0ZM6 9.5C6 9.10218 6.15804 8.72064 6.43934 8.43934C6.72064 8.15804 7.10218 8 7.5 8H24.5C24.8978 8 25.2794 8.15804 25.5607 8.43934C25.842 8.72064 26 9.10218 26 9.5C26 9.89782 25.842 10.2794 25.5607 10.5607C25.2794 10.842 24.8978 11 24.5 11H7.5C7.10218 11 6.72064 10.842 6.43934 10.5607C6.15804 10.2794 6 9.89782 6 9.5ZM12 17.5C12 17.1022 12.158 16.7206 12.4393 16.4393C12.7206 16.158 13.1022 16 13.5 16H18.5C18.8978 16 19.2794 16.158 19.5607 16.4393C19.842 16.7206 20 17.1022 20 17.5C20 17.8978 19.842 18.2794 19.5607 18.5607C19.2794 18.842 18.8978 19 18.5 19H13.5C13.1022 19 12.7206 18.842 12.4393 18.5607C12.158 18.2794 12 17.8978 12 17.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.09f0c6e0de849a84832d7c7a7a383af8.svg";
export { ForwardRef as ReactComponent };